import { IconUserPlus } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import Fab from '@/components/Fab/Fab';
import FabPopupItem from '@/components/Fab/FabPopupItem';

interface AddTeamMemberFabProps {
  onAddTeamMember: () => void;
  setShowAddTeamMembersMenu: (show: boolean) => void;
  showAddTeamMembersMenu: boolean;
}

const AddTeamMemberFab: React.FC<AddTeamMemberFabProps> = ({
  onAddTeamMember,
  setShowAddTeamMembersMenu,
  showAddTeamMembersMenu,
}) => {
  const { t } = useTranslation();
  return (
    <Fab
      isOpen={showAddTeamMembersMenu}
      onClick={() => setShowAddTeamMembersMenu(!showAddTeamMembersMenu)}
      onClose={() => setShowAddTeamMembersMenu(false)}
      icon="add-team-member"
    >
      <FabPopupItem
        data-testid="AddTeamMembersMenu"
        icon={<IconUserPlus />}
        onClick={onAddTeamMember}
        title={t('Generic.teamMembers')}
      />
    </Fab>
  );
};

export default AddTeamMemberFab;
